export class ConferenceChat {
  /**
   * The chat transport deliberately knows nothing about the DOM.  Preact owns
   * rendering; this class only turns FastPubSub packets into chat objects.
   */
  constructor({ onMessage }) {
    this.onMessage = onMessage;
    this.seen = new Set();
  }

  start(client, tenant, { subscribePatterns, publishChannel }) {
    this.client = client;
    this.tenant = tenant;
    this.publishChannel = publishChannel;
    this.stopped = false;
    for (const pattern of subscribePatterns) void this.subscribe(pattern);
  }

  async subscribe(pattern) {
    const queue = await this.client.subscribe(this.tenant, pattern);
    while (!this.stopped) {
      const message = await queue.recv(); if (!message || this.stopped) break;
      try { this.add(JSON.parse(new TextDecoder().decode(message.payload))); } catch { /* malformed chat */ }
    }
  }

  async send(participant, text) {
    const messageText = text.trim();
    if (!messageText || !this.client || !this.publishChannel) return;
    const chat = { id: crypto.randomUUID(), from: participant.participant_id, name: participant.display_name, text: messageText };
    await this.client.publish(this.tenant, this.publishChannel, JSON.stringify(chat));
    this.add(chat);
  }

  add(chat) {
    if (!chat?.id || this.seen.has(chat.id)) return;
    this.seen.add(chat.id);
    this.onMessage({ ...chat, name: chat.name || chat.from, text: chat.text || "" });
  }

  stop() { this.stopped = true; }
}
